import { useEffect, useState } from "react";
import { Badge, Collapse, Dropdown, Form } from "react-bootstrap";
import userFilter from "../../../hooks/filter/useFilter";
import { FilterNeighbourhood } from "../FilterNeighbourhood/FilterNeighbourhood";
import "./FilterEstate.scss";
import useCountry from "../../../hooks/config/useConfig";
import { Department } from "../../../interfaces/locations";

export const FilterEstateDropdown = ({ estate, currentEstate }: { estate: Department, currentEstate: Department[] }) => {
  const { filterState, setFilter } = userFilter();
  const [active, setActive] = useState(false);
  const [openCollapse, setOpenCollapse] = useState<any[]>([]);
  const [counter, setCounter] = useState(0);
  const neighbourhoodsOfEstate = estate.zones
  const [hasOpened , setHasOpened] = useState<any[]>([])
  const { country } = useCountry();

  useEffect(() => {
    setActive(currentEstate.findIndex((e) => e.id == estate.id) >= 0)
  }, [currentEstate, estate])

  const checkEstate = () =>{
    setActive(prev => !prev)
    
    // Update search tags with estate name when toggled
    const currentSearch = Array.isArray(filterState.search) ? [...filterState.search] : [];
    const estateName = (estate.name || '').toString();
    
    const estateZoneIds = new Set((neighbourhoodsOfEstate || []).map((n: any) => n.id));
    const currentLocation = [...(filterState.location || [])];
    let currentNeighbourhood = [...(filterState.neighbourhood || [])];

    if (!active) {
      // Selecting estate: add its name if not present
      if (estateName && !currentSearch.map(s => s.toLowerCase()).includes(estateName.toLowerCase())) {
        currentSearch.push(estateName);
      }
      if (!currentLocation.includes(estate.id)) currentLocation.push(estate.id);
      currentNeighbourhood = currentNeighbourhood.filter((zid) => !estateZoneIds.has(zid));
    } else {
      // Deselecting estate: remove its name and children names
      const namesToRemove: string[] = [estateName]
        .concat((neighbourhoodsOfEstate || []).map((n: any) => (n?.name || '').toString()))
        .filter(Boolean);
      const namesToRemoveLower = namesToRemove.map(n => n.toLowerCase());
      const filtered = currentSearch.filter(t => !namesToRemoveLower.includes(t.toLowerCase()));
      currentSearch.length = 0;
      currentSearch.push(...filtered);
      const locIdx = currentLocation.indexOf(estate.id);
      if (locIdx >= 0) currentLocation.splice(locIdx, 1);
      currentNeighbourhood = currentNeighbourhood.filter((zid) => !estateZoneIds.has(zid));
    }
    
    // Only manage search tags for unified search
    setFilter({ 
      search: currentSearch.length > 0 ? currentSearch : undefined,
      location: currentLocation.length > 0 ? currentLocation : undefined,
      neighbourhood: currentNeighbourhood.length > 0 ? currentNeighbourhood : undefined,
      commune: undefined,
    });
    
    setCounter(0);
  }

  const handleChange = (e: any) => {
    
    if (e.target.classList.contains('form-check-input')) {
      checkEstate()
    } else {
      //Abrir dropdown
      if(neighbourhoodsOfEstate.length >0 ){
        const collapseIndex = openCollapse.findIndex((collapse) => collapse == estate.id);

        if (collapseIndex >= 0) {
          setOpenCollapse([
            ...openCollapse.slice(0, collapseIndex),
            ...openCollapse.slice(collapseIndex + 1, openCollapse.length)
          ])
        } else {
          //Guarda que ya se renderizó
          if(!hasOpened.includes(estate.id)){
            setHasOpened(prev => [...prev,estate.id])
          }
          setOpenCollapse(openCollapse => [...openCollapse, estate.id])
          
        }
        
      }else{
        //No tiene barrios , marcar check
        checkEstate()
      }
      
    }
  };
  
  return (
    <>
      <Dropdown.Item
      onClick={(e) => handleChange(e)}
        key={`estate-${estate.id}`}
        className={`d-flex align-items-center px-2 py-2 my-1 rounded-1 ${active ? "bg-sm-light" : ""
          }`}
      >
        <Form.Check 
          className="me-2 d-flex align-items-center w-100 form-check-estate">
          <Form.Check.Input checked={active} id={`estate-${estate.id}`} type="checkbox" onClick={e => e.stopPropagation()} onChange={e => handleChange(e)} />
          <Form.Check.Label htmlFor={`estate-${estate.id}`} >{`${country === "CL" ? 'Región' : ''} ${estate.name}`}</Form.Check.Label>
        </Form.Check>

        {(!active && counter > 0) && (
          <small className="d-flex align-items-center">
            <Badge pill bg="primary" className="badge-check ms-2">
              {counter}
            </Badge>
          </small>
        )}
      </Dropdown.Item>

      <Collapse className={`parent-estate-${estate.id}`} key={`collapse-${estate.id}`} in={openCollapse.findIndex((collapse) => collapse == estate.id) >= 0}>
        <div className="neighbourhood-collapse">
          {
            hasOpened.includes(estate.id) && 
            <FilterNeighbourhood  estate={estate} activeParent={active} setActiveParent={setActive} setCounter={setCounter} />
          } 
        </div>
      </Collapse>
    </>
  );
};
